export default __webpack_public_path__ + "static/media/bg-masthead-3.ccb5d6d8.jpg";